import { useEffect, useState } from 'react';
import { usePosthog } from './usePosthog';

export type TFeatureFlagVariantStatus = 'loading' | 'enabled' | 'disabled';

/** Tri-state flag check. Distinguishes "not resolved" from "non-matching variant". */
export const useFeatureFlagVariantState = (
  flagKey: string,
  expectedVariant: string,
): TFeatureFlagVariantStatus => {
  const posthogService = usePosthog();
  const [status, setStatus] = useState<TFeatureFlagVariantStatus>('loading');

  useEffect(() => {
    if (!posthogService) {
      setStatus('disabled');
      return;
    }

    const sync = () => {
      const matched = posthogService.isFeatureFlagVariant(flagKey, expectedVariant);
      setStatus(matched ? 'enabled' : 'disabled');
    };

    posthogService.onFeatureFlags(sync);
    posthogService.reloadFeatureFlags();
  }, [flagKey, expectedVariant, posthogService]);

  return status;
};
